import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, IconButton, Stack, Typography, useTheme } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Profile } from '@par/shared/types/player';
import { resizeImage } from '../../api/cloudinary';
import { DrawerButton, ExpandIcon, getWhosOnlineCount } from '.';
import { MAX_PLAYERS_ONLINE_COUNT } from '../main/WhosOnlineCard';
import { WhosOnline } from '../room/types';
import { getAvatarSrc } from '../room/utils';

type Props = {
  onlinePlayerCount: number;
  openMessagesDrawer: boolean;
  profile: Profile;
  setOpenMessagesDrawer: (open: boolean) => void;
  whosOnline: WhosOnline[];
};

export const DrawerButtonWhosOnline = ({
  onlinePlayerCount,
  openMessagesDrawer,
  profile,
  setOpenMessagesDrawer,
  whosOnline,
}: Props) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleAvatarClick = (event) => {
    event.stopPropagation();
    navigate(`/profile/overview/${profile.id}`);
  };

  return (
    <DrawerButton
      onClick={(event) => setOpenMessagesDrawer(!openMessagesDrawer)}
      sx={
        !openMessagesDrawer
          ? {
              border: `1px solid ${theme.palette.primary.dark}`,
              borderBottom: 'none',
              '&:hover': {
                backgroundColor: '#8f7462',
              },
            }
          : null
      }
    >
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        spacing={2}
        width={'100%'}
        height={'100%'}
      >
        <Avatar
          src={getAvatarSrc(
            profile?.avatarPublicId,
            profile?.avatarUrl,
            100,
            100
          )}
          onClick={handleAvatarClick}
          sx={{
            width: 32,
            height: 32,
            '&:hover': {
              boxShadow:
                '0px 0px 4px -1px #cda68c, 0px 0px 5px 0px #cda68c, 0px 0px 10px 0px #cda68c',
            },
          }}
        />
        <Stack
          direction={'row'}
          spacing={1}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Typography color="success.main">
            {onlinePlayerCount > MAX_PLAYERS_ONLINE_COUNT
              ? onlinePlayerCount
              : getWhosOnlineCount(whosOnline, profile.id)}
          </Typography>{' '}
          <Typography textTransform={'capitalize'} whiteSpace={'nowrap'}>
            Player{getWhosOnlineCount(whosOnline, profile.id) !== 1 ? 's' : ''}{' '}
            Online
          </Typography>
        </Stack>

        <ExpandIcon aria-label="expand">
          {openMessagesDrawer ? <ExpandMore /> : <ExpandLess />}
        </ExpandIcon>
      </Stack>
    </DrawerButton>
  );
};
